import React from 'react'

export const PixelsLogo: React.FC = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='91.32'
		height='28.41'
		className='pixels-logo-icon-svg'
		viewBox='0 0 115.323 28.41'>
		<g
			id='Group_4821'
			data-name='Group 4821'
			transform='translate(-5.523 -0.867)'>
			<g id='Group_4834' data-name='Group 4834'>
				<text
					id='Pexels'
					transform='translate(36.846 25.278)'
					fill='#fff'
					font-size='21'
					font-family='Lato-Heavy, Lato'
					font-weight='800'>
					<tspan x='0' y='0'>
						Pexels
					</tspan>
				</text>
				<g
					id='Group_4483'
					data-name='Group 4483'
					transform='translate(5.523 0.867)'>
					<path
						id='Path_3380'
						data-name='Path 3380'
						d='M-13.942,85.694q0-6.81-.007-13.62c0-.295.068-.367.365-.366,4.742.012,9.483,0,14.225.013a10.35,10.35,0,0,1,9.765,7.816,9.948,9.948,0,0,1-2.171,9.033,10.088,10.088,0,0,1-5.944,3.446c-.255.049-.3.138-.295.364.007,2.332,0,4.663.01,6.995,0,.252-.047.34-.325.34q-7.65-.014-15.3,0c-.269,0-.328-.076-.328-.334Q-13.936,92.537-13.942,85.694Z'
						transform='translate(13.949 -71.708)'
						fill='#fefefe'
					/>
					<path
						id='Path_3381'
						data-name='Path 3381'
						d='M46.057,140.772c0-3.227,0-6.454-.007-9.681,0-.286.078-.344.352-.343,3.294.01,6.589,0,9.883.008a6.253,6.253,0,0,1,.908,12.447,26.844,26.844,0,0,1-2.919.058c-.29,0-.375.065-.373.367.014,2.275,0,4.549.014,6.824,0,.285-.084.35-.357.349q-3.6-.015-7.194,0c-.252,0-.314-.062-.313-.314Q46.065,145.629,46.057,140.772Z'
						transform='translate(-42.008 -126.77)'
						fill='#00a27e'
					/>
				</g>
			</g>
		</g>
	</svg>
)

export const BackgroundRemoverLogo: React.FC = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='27.382'
		height='25.653'
		className='backgroundremoverlogo-icon-svg'
		viewBox='0 0 34.382 32.653'>
		<g id='Group_4836' data-name='Group 4836' transform='translate(-577 -424)'>
			<g id='Group_4835' data-name='Group 4835' transform='translate(577 424)'>
				<path
					id='Path_3563'
					data-name='Path 3563'
					d='M309.049,531.541l-14.5,7.636a4.362,4.362,0,0,1-4.064,0l-14.5-7.636a1.226,1.226,0,0,1,.033-2.186l16.5-8.058,16.5,8.058A1.226,1.226,0,0,1,309.049,531.541Z'
					transform='translate(-275.322 -507.027)'
					fill='#ff83a4'
				/>
				<path
					id='Path_3564'
					data-name='Path 3564'
					d='M309.049,418.74l-14.5,7.636a4.362,4.362,0,0,1-4.064,0l-14.5-7.636a1.226,1.226,0,0,1,.033-2.186l16.5-8.059,16.5,8.059A1.226,1.226,0,0,1,309.049,418.74Z'
					transform='translate(-275.322 -399.166)'
					fill='#ffacc2'
					opacity='0.998'
				/>
				<path
					id='Path_3565'
					data-name='Path 3565'
					d='M309.049,306.569l-14.5,7.636a4.362,4.362,0,0,1-4.064,0l-14.5-7.636a1.225,1.225,0,0,1,.033-2.186l16.5-8.059,16.5,8.059A1.225,1.225,0,0,1,309.049,306.569Z'
					transform='translate(-275.322 -291.907)'
					fill='#ffd6e1'
				/>
				<path
					id='Path_3566'
					data-name='Path 3566'
					d='M309.049,205.211l-14.5,7.636a4.362,4.362,0,0,1-4.064,0l-14.5-7.636a1.226,1.226,0,0,1,.033-2.186L290.6,195.9a4.362,4.362,0,0,1,3.828,0l14.589,7.124A1.226,1.226,0,0,1,309.049,205.211Z'
					transform='translate(-275.322 -195.459)'
					fill='#fff'
				/>
			</g>
		</g>
	</svg>
)

export const CreatePostIcon: React.FC = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='22.84'
		height='22.84'
		className='createposticon-svg'
		viewBox='0 0 22.836 22.836'>
		<g id='image' transform='translate(0.577 2.582)'>
			<g id='Group_4472' data-name='Group 4472'>
				<g id='Group_4471' data-name='Group 4471'>
					<g id='Group_4491' data-name='Group 4491'>
						<path
							id='Path_3372'
							data-name='Path 3372'
							d='M19.883-1H.953A1.953,1.953,0,0,0-1,.953v18.93A1.953,1.953,0,0,0,.953,21.836h18.93a1.953,1.953,0,0,0,1.953-1.953V.953A1.953,1.953,0,0,0,19.883-1Zm-.349,19.883a.651.651,0,0,1-.651.651H1.953a.651.651,0,0,1-.651-.651V1.953A.651.651,0,0,1,1.953,1.3h16.93a.651.651,0,0,1,.651.651Z'
							transform='translate(0.423 -1.582)'
							fill='#fff'
						/>
						<g id='Group_4490' data-name='Group 4490'>
							<rect
								id='Rectangle_67'
								data-name='Rectangle 67'
								width='13'
								height='2'
								rx='1'
								transform='translate(4.423 10.418)'
								fill='#fff'
							/>
							<rect
								id='Rectangle_68'
								data-name='Rectangle 68'
								width='13'
								height='2'
								rx='1'
								transform='translate(4.423 13.418)'
								fill='#fff'
							/>
							<circle
								id='Ellipse_4'
								data-name='Ellipse 4'
								cx='2.5'
								cy='2.5'
								r='2.5'
								transform='translate(8.423 2.418)'
								fill='#fff'
							/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
)

export const PixelsBlockLogo: React.FC = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='70'
		height='70'
		className='pixels-block-logo-svg'
		viewBox='0 0 70 70'>
		<g id='Group_4957' data-name='Group 4957' transform='translate(-516 -202)'>
			<rect
				id='Rectangle_5'
				data-name='Rectangle 5'
				width='70'
				height='70'
				rx='15'
				transform='translate(516 202)'
				fill='#00a27e'
			/>
			<g
				id='Group_4834'
				data-name='Group 4834'
				transform='translate(529.477 218.133)'>
				<g
					id='Group_4483'
					data-name='Group 4483'
					transform='translate(10.754 4.538)'>
					<path
						id='Path_3380'
						data-name='Path 3380'
						d='M-13.942,86q0-6.96-.007-13.919c0-.3.069-.375.373-.374,4.846.012,9.692,0,14.538.013a10.578,10.578,0,0,1,9.98,7.988,10.167,10.167,0,0,1-2.219,9.232,10.31,10.31,0,0,1-6.075,3.522c-.26.051-.3.141-.3.372.007,2.383,0,4.766.01,7.149,0,.257-.049.348-.332.347q-7.819-.014-15.638,0c-.275,0-.335-.077-.335-.341Q-13.936,93-13.942,86Z'
						transform='translate(13.949 -71.708)'
						fill='#fefefe'
					/>
					<path
						id='Path_3381'
						data-name='Path 3381'
						d='M46.057,140.992c0-3.3,0-6.6-.007-9.894,0-.292.08-.352.36-.351,3.367.01,6.734,0,10.1.008a6.391,6.391,0,0,1,.928,12.721,27.438,27.438,0,0,1-2.983.059c-.3,0-.383.066-.382.375.014,2.325,0,4.65.014,6.974,0,.291-.086.358-.365.357q-3.676-.016-7.352,0c-.258,0-.321-.064-.32-.32Q46.065,145.957,46.057,140.992Z'
						transform='translate(-41.919 -126.683)'
						fill='#00a27e'
					/>
				</g>
			</g>
		</g>
	</svg>
)

export const SearchIcon: React.FC = () => (
	<svg
		id='loupe'
		xmlns='http://www.w3.org/2000/svg'
		width='25.216'
		height='25.216'
		viewBox='0 0 25.216 25.216'>
		<g id='Group_4954' data-name='Group 4954'>
			<g id='Group_4953' data-name='Group 4953'>
				<path
					id='Path_3580'
					data-name='Path 3580'
					d='M11.1,0a11.1,11.1,0,1,0,11.1,11.1A11.117,11.117,0,0,0,11.1,0Zm0,20.159A9.054,9.054,0,1,1,20.159,11.1,9.065,9.065,0,0,1,11.1,20.159Z'
					fill='#7a719b'
				/>
			</g>
		</g>
		<g
			id='Group_4956'
			data-name='Group 4956'
			transform='translate(17.289 17.289)'>
			<g id='Group_4955' data-name='Group 4955'>
				<path
					id='Path_3581'
					data-name='Path 3581'
					d='M358.672,357.223l-5.877-5.877a1.025,1.025,0,0,0-1.449,1.449l5.877,5.877a1.025,1.025,0,0,0,1.449-1.449Z'
					transform='translate(-351.046 -351.046)'
					fill='#7a719b'
				/>
			</g>
		</g>
	</svg>
)
